module.exports = __webpack_public_path__ + "img/delete.519bd3cd.svg";